import { Variants } from '@ds/components/Picker'

import {
  PICKER_GROUP_WITH_THEME,
  PICKER_VARIANT_TO_COLOR,
} from './Pickers.constants'

const getSelectedMasterPicker = (pickers) => {
  const pickerGroup =
    pickers.find(({ id }) => id === PICKER_GROUP_WITH_THEME)?.items ?? []
  const selectedPicker = pickerGroup.find(({ selected }) => !!selected)

  return selectedPicker
}

/**
 * When a "recommended variants" picker is selected, it's theme is applied to all selected pickers.
 * Let's find out right here which color variant will be applied then!
 */
export const getPickerVariantForSelectedPickers = (pickers) => {
  const selectedPicker = getSelectedMasterPicker(pickers)

  return selectedPicker?.emphasis ?? Variants.Default
}

export const getColorVariantForSelectedPickers = (pickers) => {
  return PICKER_VARIANT_TO_COLOR[getPickerVariantForSelectedPickers(pickers)]
}

export const getColorLabelForSelectedPickers = (pickers) => {
  const selectedPicker = getSelectedMasterPicker(pickers)

  return selectedPicker?.label ?? ''
}
